import * as log from "loglevel";
if (process.env.NODE_ENV != "production") log.setLevel("debug");
import moment from "moment-timezone";

export class DepartureTimes {
  constructor(renderEmptyRoutes = false, maxRouteTimes = 3) {
    this.renderEmptyRoutes = renderEmptyRoutes;
    this.maxRouteTimes = maxRouteTimes;
  }

  init() {
    window.fetchTransitDelay = 30000;
    this.fetchAndRenderRoutes();
    // we're creating the scroll buttons over and over again, so delegate it and trigger things
    $("#transitdisplay-active-pane").on(
      "click",
      ".scrollbtn-wrappers a",
      function(event) {
        event.preventDefault();
        let scrollOffset = $("#transitdisplay-active-pane").scrollTop() - 150;
        // set to positive amount if scrolling down, otherwise it stays negative from above
        if ($(event.target).is("#scrollbtn-down")) {
          scrollOffset += 300;
        }
        $("#transitdisplay-active-pane").animate({
          scrollTop: scrollOffset,
        });
      }
    );
  }

  stopHeader(stopData) {
    if (stopData.kind == "bus") {
      return '<h2>Buses <span class="bus-logo"><small></small></span></h2>';
    } else {
      return '<h2>Metro Rail <span class="rail-logo"><small></small></span></h2>';
    }
  }

  agencyLogo(routeData) {
    if (routeData.agency == "ladot-dash") {
      return `<img src="${window.transitDisplayData.assetUrls["ladotDashLogo"]}" class="image-logo">`;
    } else if (["la-metro", "la-metro-rail"].includes(routeData.agency)) {
      // it's lametro or lametro_rail
      return '<span class="metro-logo">M</span><small>Metro</small>';
    } else {
      if (routeData["logo_url"]) {
        return `<img src="${routeData["logo_url"]}" class="image-logo">`;
      } else {
        return "";
      }
    }
  }

  renderStopPane(stopData) {
    // If we have manually set transit kinds, and this isn't one of them, don't render anything
    if (
      window.transitDisplayData.kind != "all" &&
      window.transitDisplayData.kind !== stopData.kind
    ) {
      return "";
    }

    return `<div class="departure-times-pane">
      <header class="departure-times-header">
        <div class="title-header">${this.stopHeader(stopData)}</div>
        <div class="location-header">
          <h3>${stopData.name}</h3>
        </div>
      </header>
      <ul class="departure-list">
        ${Object.values(stopData.routes)
          .sort((a, b) => {
            //  exclude stuff that is before now.
            let filteredDeparturesA = a.departures.filter(
              d => d > this.earliestNowTime
            );
            let filteredDeparturesB = b.departures.filter(
              d => d > this.earliestNowTime
            );

            // make sure the stops are in order, soonest one first.
            return filteredDeparturesA[0] - filteredDeparturesB[0];
          })
          .map(v => this.renderRouteListItem(v))
          .join("")}
      </ul>
    </div>`;
  }

  // NOTE: this is used in AdminTransitIntegration
  renderRouteListItem(routeData) {
    let departureMinList = this.departuresMinList(routeData.departures || []);
    // return blank if there aren't any departures coming up!
    if (departureMinList.length < 1 && !this.renderEmptyRoutes) {
      return "";
    }
    // If render_color is false, we don't include the color
    const transitLineColor = routeData.render_color
      ? `<span class="transit-line-color" style="background: ${routeData.line_color};"></span>`
      : "";

    const onlyNowText =
      departureMinList.length === 1 && departureMinList[0] === "now";

    const departureTimesText = `
       <h4>${`${departureMinList.join(",")}
      ${onlyNowText ? "" : "<small> min</small>"}   
      `}`;

    return `<li class="row">
      <div class="provider-logo-wrapper">
        ${this.agencyLogo(routeData)}
      </div>
      <div class="departure-details">
        <div class="row">
          <div class="line-info col">
            <h4>
            ${transitLineColor}
            ${routeData.name}
            </h4>
          </div>
          <div class="departure-time-clock col">
         ${departureTimesText}
          </div>
          <div class="col-12">${routeData.description}</div>
        </div>
      </div>
      <div class="only-dev-visible debug-integration-display">Integration ID: ${
        routeData.integration_id
      }</div>
    </li>`;
  }

  departuresMinList(departureList) {
    const timeList = departureList
      .map(t => {
        let secondsLeft = moment.unix(t).diff(window.currentTime, "seconds");
        let minutesLeft = moment.unix(t).diff(window.currentTime, "minutes");
        // If minutes are -1 or -2, assume that the departure is still there and make it 0
        if (minutesLeft < 0 && minutesLeft > -2) {
          minutesLeft = 0;
        }

        // if secondsLeft are in the next or previous 30 seconds;
        const nextThirtySeconds = secondsLeft + 30;
        const previousThirtySeconds = secondsLeft - 30;

        if (nextThirtySeconds <= 30 || previousThirtySeconds <= 30) {
          return "now";
        } else {
          return minutesLeft;
        }
      })
      .filter(t => {
        if (t === "now") return "now";
        return t > 0;
      });

    return timeList.slice(0, this.maxRouteTimes);
  }

  renderDepartures(stops) {
    window.currentTime = moment();
    this.earliestNowTime = moment().unix() - 30; // timestamp in unix minus 30 seconds from now

    // empty the pane - currently experimenting with scroll arrows
    const blankPane =
      "<div class='row pane-wrapper'></div><div class='scrollbtn-wrappers'><a id='scrollbtn-up' href='#'>&#8593;</a><a id='scrollbtn-down' href='#'>&#8595;</a></div>";
    $("#transitdisplay-active-pane").html(blankPane);
    stops.forEach(stopData => {
      $("#transitdisplay-active-pane .pane-wrapper").append(
        this.renderStopPane(stopData)
      );
    });
  }

  fetchAndRenderRoutes() {
    // If we aren't on the departure times pane, exit departure times
    if (window.transitDisplayData.activeSection !== "departure_times") {
      log.debug(
        "active_section is not departure times. Exiting fetchAndRenderRoutes"
      );
      return;
    }
    const self = this;

    fetch(`/api/v1/transit_displays/${window.transitDisplayData.displayId}`)
      .then(response => response.json())
      .then(transitScreenData => {
        // If we set fetchTransitDelay to 0, don't loop
        if (window.fetchTransitDelay != 0) {
          window.setTimeout(() => {
            self.fetchAndRenderRoutes();
          }, window.fetchTransitDelay);
        }
        if (transitScreenData.stops) {
          self.renderDepartures(transitScreenData.stops);
        } else {
          log.warn("Error! couldn't parse response", transitScreenData);
        }
      });
  }
}
